import { Component, inject, OnInit, DOCUMENT } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventService } from '../../core/services/event.service';
import { SimplebarAngularModule } from 'simplebar-angular';

import {
  LAYOUT_WIDTH,
  SIDEBAR_TYPE,
  TOPBAR,
  LAYOUT_MODE,
} from '../layouts.model';

@Component({
  selector: 'app-rightsidebar',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SimplebarAngularModule
  ],
  templateUrl: './rightsidebar.component.html',
  styleUrls: ['./rightsidebar.component.scss'],
})
export class RightsidebarComponent implements OnInit {
  isVisible: string = '';
  attribute: string = '';
  document = inject(DOCUMENT);
  width: string = '';
  sidebartype: string = '';
  mode: string = '';
  topbar: string = '';

  eventService = inject(EventService);

  ngOnInit() {
    this.width = LAYOUT_WIDTH;
    this.topbar = TOPBAR;
    const themeMode = localStorage.getItem('themeMode') || LAYOUT_MODE;
    const themeSideBar = localStorage.getItem('themeSideBar') || SIDEBAR_TYPE;
    this.changeMode(themeMode);
    this.changeSidebartype(themeSideBar);
    /**
     * horizontal-vertical layput set
     */
    this.attribute = document.body.getAttribute('data-layout') ?? '';
    const vertical = document.getElementById('is-layout');
    if (vertical != null) {
      vertical.setAttribute('checked', 'true');
    }
    if (this.attribute == 'horizontal') {
      vertical?.removeAttribute('checked');
    }
    this.changeMode(themeMode ?? 'light');
  }

  /**
   * Hide the sidebar
   */
  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  /**
   * Change Topbar
   */
  changeTopbar(topbar: string) {
    this.topbar = topbar;
    this.eventService.broadcast('changeTopbar', topbar);
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: any) {
    if (layout.target.checked == true)
      this.eventService.broadcast('changeLayout', 'vertical');
    else this.eventService.broadcast('changeLayout', 'horizontal');
  }

  changeWidth(width: string) {
    this.width = width;
    this.eventService.broadcast('changeWidth', width);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  changeSidebartype(sidebar: string) {
    this.sidebartype = sidebar;
    this.eventService.broadcast('changeSidebartype', sidebar);
    localStorage.setItem('themeSideBar', sidebar);
  }

  changeMode(themeMode: string) {
    this.mode = themeMode;
    this.eventService.broadcast('changeMode', themeMode);
    const link = document.getElementById('theme-css') as HTMLLinkElement;
    const theme = themeMode === 'dark' ? 'lara-dark-blue' : 'saga-blue';
    if (link) {
      link.href = `assets/themes/${theme}/theme.css`;
    }
    this.eventService.theme.set(themeMode);
    localStorage.setItem('themeMode', themeMode);
  }

}
